<template>
  <div
    v-if="
      (member.Active__c &&
        !member.npsp__Deceased__c &&
        (!member.Household_Role__c || member.Household_Role__c === 'Main') &&
        this.taskId !== null) ||
      isLoading
    "
    :class="{
      'print-card-container': true,
      family: member.Household_Role__c === 'Main',
    }"
  >
    <template v-if="!isLoading">
      <v-btn
        small
        depressed
        color="#b8e994"
        @click="print"
        v-if="
          member.Active__c &&
          !member.npsp__Deceased__c &&
          (!member.Household_Role__c || member.Household_Role__c === 'Main') &&
          this.taskId !== null
        "
      >
        <v-icon small left> mdi-printer </v-icon>
        <span v-if="member.Household_Role__c === 'Main'"
          >Isprintaj obiteljske iskaznice</span
        >
        <span v-else>Isprintaj iskaznicu</span>
      </v-btn>
    </template>
    <div class="print-loading" v-else>
      <v-progress-circular indeterminate color="#1358a3"></v-progress-circular>
    </div>
    <v-alert outlined text type="error" class="print-error" v-show="error">
      {{ error }}
    </v-alert>
    <div v-if="test" v-html="test"></div>
  </div>
</template>

<script>
import apiRequest from "../../helpers/apiRequest";

export default {
  props: ["member"],
  data() {
    return {
      taskId: null,
      error: false,
      isLoading: false,
      test: null,
    };
  },
  watch: {
    member() {
      this.fetchPrintTask();
    },
  },
  mounted() {
    this.fetchPrintTask();
  },
  methods: {
    async fetchPrintTask() {
      if (this.member && this.member.Id) {
        try {
          const taskId = await apiRequest(
            "get",
            `members/print-task/${this.member.Id}`
          );

          this.taskId = taskId;
        } catch (error) {
          this.error = error.response.data.message;
        }
      }
    },
    async print() {
      this.error = false;
      this.isLoading = true;

      try {
        let printHtml = await apiRequest("get", `members/print/${this.taskId}`);

        let styleClose = "</style>";

        let splitHtml = printHtml.split(styleClose);

        if (splitHtml && splitHtml.length > 1) {
          let newFontFaces = `
            @font-face {
              font-family: 'Tisa-Sans-Pro-Extra-Bold-Custom';
              src: url(https://test-dphapp.nashajduk.hr/fonts/TisaSansPro_ExtraBold.woff2) format('woff2');
              font-weight: 800;
              font-style: normal;
            }

            @font-face {
              font-family: 'Tisa-Sans-Pro-Medium-Custom';
              src: url(https://test-dphapp.nashajduk.hr/fonts/TisaSansPro_Medium.woff2) format('woff2');
              font-weight: 500;
              font-style: normal;
            }
            ${styleClose}
          `;

          let contentHtml = splitHtml[1].replaceAll(
            "Tisa-Sans-Pro-Extra-Bold",
            "Tisa-Sans-Pro-Extra-Bold-Custom"
          );

          contentHtml = contentHtml.replaceAll(
            "Tisa-Sans-Pro-Medium",
            "Tisa-Sans-Pro-Medium-Custom"
          );

          printHtml = splitHtml[0] + newFontFaces + contentHtml;
        }

        let win = window.open();
        win.document.body.innerHTML = printHtml;
        setTimeout(() => {
          win.print();
          win.close();
        }, 250);
      } catch (error) {
        if (error?.response?.data?.message)
          this.error = error.response.data.message;
        else {
          this.error = "Something went wrong. Please try again";
          console.log(error);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.print-card-container {
  width: 200px;
  display: flex;
  flex-direction: column;

  &.family {
    width: 280px;
  }

  .print-loading {
    display: flex;
    justify-content: center;
  }
}

.print-error {
  margin-top: 12px;
}
</style>
